import request from '../utils/request';
import qs from "qs";

export function getOrderList(param) {
	return request({
		url: '/admin/search-order',
		method: 'GET',
		params: param
	})
}

export function getOrderStatusName() {
	return request({
		url: '/admin/order-status-name'
	})
}

export function applyRefund(order_id, data) {
	return request({
		url: '/admin/order/'+order_id+'/apply-refund',
		method: 'PUT',
		headers: { 'content-type': 'application/x-www-form-urlencoded' },
		data: qs.stringify(data)
	})
}

export function sendProduct(order_id) {
	return request({
		url: '/admin/order/'+order_id+'/send-product',
		method: 'PUT',
	})
}

export function orderCancel(order_id) {
	return request({
		url: '/admin/order/'+order_id+'/cancel',
		method: 'PUT',
	})
}

export function getOrderExcel(param) {
	return request({
		url: '/admin/getOrderExcel',
		method: 'GET',
		params: param
	})
}

